import { Punctuation } from 'enums';

export type AmountObject = {
  bills: string;
  coins: string
}
type FormatAmountParams = {
  amount?: string | number;
  divider?: Punctuation;
  rounding?: boolean;
  returnAsObject?: boolean;
  trim?: boolean;
};

export const formatAmount = ({
     amount = 0,
     divider = Punctuation.POINT,
     rounding = true,
     trim = false,
     returnAsObject = false,
   }: FormatAmountParams): string | AmountObject => {
  const parsedAmount = parseInt(`${amount}`, 10);
  const tempAmount = parsedAmount.toString().split('');

  if (isNaN(parsedAmount)) {
    return rounding ? '0' : `0${divider}00`;
  }

  if (tempAmount.length <= 1) {
    if (rounding && Number(amount) === 0) {
      return '0';
    }
    return `0${divider}0${parsedAmount}`;
  }

  if (tempAmount.length <= 2) {
    return `0${divider}${parsedAmount}`;
  }

  const coins = tempAmount.splice(-2).join('');

  const bills = tempAmount
    .reverse()
    .reduce((acc: string[], val: string, index: number) => {
      if ((index + 1) % 3 === 0 && index - 1 !== 0 && index !== tempAmount.length - 1) {
        acc.unshift(trim ? `${val}` : ` ${val}`);
        return acc;
      }
      acc.unshift(val);
      return acc;
    }, [])

    .join('');
  const result = coins === '00' && rounding ? `${bills}` : `${bills}${divider}${coins}`;
  return returnAsObject ? {bills, coins} : result;
};
